import { useTranslation } from 'react-i18next'

import { Alert, Text, WarningIcon } from '@mercai/clever'

import styles from './alert-smart-search.module.css'
import { KaiAlert } from '@/components'

export const AlertSmartSearch = ({
  smartSearchUUID,
}: {
  smartSearchUUID: string | null | undefined
}) => {
  const { t } = useTranslation('screenCatalogProduct')

  return (
    <>
      {smartSearchUUID && (
        <KaiAlert title={t('smartSearchLoadingTitle')}>
          <div className={styles['smart-search-alert']}>
            <Text variant="text-small" className={styles['smart-search-text']}>
              {t('smartSearchLoadingDescription')}
            </Text>

            <Text variant="text-small" className={styles['smart-search-text']}>
              {t('smartSearchLoadingDescription2')}
            </Text>
          </div>
        </KaiAlert>
      )}

      {smartSearchUUID === null && (
        <Alert leftIcon={<WarningIcon />} variant="danger">
          {t('smartSearchFormNotFound')}
        </Alert>
      )}
    </>
  )
}
